import { createFileRoute } from "@tanstack/react-router";
import { View } from "../app/components/framework/view";
import { ResultTable } from "../app/features/results/resultTable";

export const Route = createFileRoute("/resultsTable")({
  component: () => (
    <View fullWidth>
      <ResultTable />
    </View>
  ),
});
